import React from 'react';
import ReactDOM from 'react-dom/client';
// @ts-ignore: side-effect import of CSS without type declarations
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserProvider } from "./contexts/UserContext";
import { BusinessProvider } from "./contexts/BusinessContext";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <UserProvider>
      <BusinessProvider>
        <App />
      </BusinessProvider>
    </UserProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
